module.exports = "pegasus/assets/theme3/small/6.jpg";